import { AxiosError } from 'axios'

import { authStatusHandler } from 'shared/store'

import { getRequest, postRequest } from '@utils/axios/baseRequests'
import { AuthStatus } from 'shared/types'

export const redirectToLogin = () => {
  authStatusHandler(AuthStatus.NO_AUTH)
  //const itsLoginPage = window.location.pathname === '/'
  //if (!itsLoginPage) window.location.replace('/')
}

export const redirectToNotAllowed = () => {
  authStatusHandler(AuthStatus.NO_AUTH)
  const itsNotAllowedPage = window.location.pathname === '/not-allowed'
  if (!itsNotAllowedPage) window.location.replace('/not-allowed')
}

export const logout = async () => {
  try {
    const result = await postRequest(`${import.meta.env.VITE_SERVER}/api/auth/logout`, {}, {})
    if (result) {
      console.log(result)
      authStatusHandler(AuthStatus.NO_AUTH)
      //window.location.pathname = '/'
    }
  } catch (err) {
    console.log('Не удалось совершить выход', err)
  }
}

export const getNewAccessToken = async () => {
  try {
    return await postRequest(`${import.meta.env.VITE_SERVER}/api/auth/refresh-access`, {}, {})
  } catch (error) {
    const err = error as AxiosError
    if (err.message === 'Network Error') {
      toastError('Нет соединения с интернетом')
    } else console.log('Не удалось получить новый access token')
  }
}

export const getCurrUser = async () => {
  try {
    const result = await getRequest(`${import.meta.env.VITE_SERVER}/api/auth/me`)
    return result.data
  } catch (err) {
    console.log('Не удалось получить данные пользователя', err)
    return {}
  }
}
function toastError(arg0: string) {
  throw new Error('Function not implemented.')
}
